<div class="section-divider">
  <span>{{ text }}</span>
</div>
